import { render, staticRenderFns } from "./targetMilestone.vue?vue&type=template&id=285e987b&scoped=true"
import script from "./targetMilestone.vue?vue&type=script&lang=js"
export * from "./targetMilestone.vue?vue&type=script&lang=js"
import style0 from "./targetMilestone.vue?vue&type=style&index=0&id=285e987b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e987b",
  null
  
)

export default component.exports